export enum IStrapiMediaFormatSizes {
  THUMBNAIL = 'thumbnail',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large'
}

export interface IStrapiMediaFluidSize {
  maxWidth: number;
  preferredFormat: IStrapiMediaFormatSizes;
}

export interface IStrapiMediaData {
  caption: string;
  ext: string;
  hash: string;
  height: number;
  mime: string;
  name: string;
  url: string;
  width: number;
}

interface IStrapiMediaFormats {
  thumbnail: IStrapiMediaData;
  small: IStrapiMediaData;
  medium: IStrapiMediaData;
  large: IStrapiMediaData;
  [key: string]: IStrapiMediaData;
}

export interface IStrapiMedia extends IStrapiMediaData {
  alternativeText: string;
  url: string;
  hash: string;
  formats?: IStrapiMediaFormats;
}
